import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  LazyRouteGuardService,
  NoProjectsGuard,
  PermissionGuard
} from '@cbuild/core';
import { Module } from '@cbuild/shared';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { NoProjectsComponent } from './no-projects/no-projects.component';

const routes: Routes = [
  {
    path: 'accounts',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'select-org',
    loadChildren: () =>
      import('./organization-select/organization-select.module').then(
        m => m.OrganizationSelectModule
      )
  },
  {
    path: 'external-form',
    loadChildren: () =>
      import('./external-forms/external-forms.module').then(
        m => m.ExternalFormsModule
      )
  },
  {
    path: '',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [NoProjectsGuard]
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./settings/settings.module').then(m => m.SettingsModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard, NoProjectsGuard],
    data: {
      module: [Module.ADMIN]
    }
  },
  {
    path: 'sales',
    loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard, NoProjectsGuard],
    data: {
      module: [Module.SALES]
    }
  },
  {
    path: 'account-settings',
    loadChildren: () =>
      import('./account-settings/account-settings.module').then(
        m => m.AccountSettingsModule
      ),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard],
    data: {
      module: [Module.ADMIN]
    }
  },
  {
    path: 'project-configuration',
    loadChildren: () =>
      import('./project-configuration/project-configuration.module').then(
        m => m.ProjectConfigurationModule
      ),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard],
    data: {
      module: [Module.ADMIN]
    }
  },
  {
    path: 'profile-preferences',
    loadChildren: () =>
      import('./profile-preferences/profile-preferences.module').then(
        m => m.ProfilePreferencesModule
      ),
    canLoad: [LazyRouteGuardService]
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then(m => m.ReportsModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard, NoProjectsGuard]
  },
  {
    path: 'marketing',
    loadChildren: () =>
      import('./marketing/marketing.module').then(m => m.MarketingModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard, NoProjectsGuard],
    data: {
      module: [Module.CAMPAIGNS]
    }
  },
  {
    path: 'show-case',
    loadChildren: () =>
      import('./show-case/show-case.module').then(m => m.ShowCaseModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [NoProjectsGuard]
  },
  {
    path: 'operations',
    component: UnderConstructionComponent,
    canActivate: [PermissionGuard, NoProjectsGuard],
    data: {
      module: [Module.OPS]
    }
  },
  {
    path: 'no-projects',
    component: NoProjectsComponent
  },
  {
    path: 'common-booking',
    loadChildren: () =>
      import(
        './common/common-booking-details/common-booking-details.module'
      ).then(m => m.CommonBookingModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard, NoProjectsGuard],
    data: {
      module: [Module.CRM]
    }
  },
  {
    path: 'log-history',
    loadChildren: () =>
      import('./common/audit-log/audit-log.module').then(m => m.AuditLogModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard],
    data: {
      module: [Module.ADMIN]
    }
  },
  {
    path: 'crm',
    loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule),
    canLoad: [LazyRouteGuardService],
    canActivate: [PermissionGuard, NoProjectsGuard],
    data: {
      module: [Module.CRM]
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
